export const ObtenerSucursales = "ObtenerSucursales";
export const Cargando = "SUCURSAL_CARGANDO";
export const Error = "SUCURSAL_ERROR";
